import React, { lazy, Suspense } from 'react'
const MUIRichTextEditor = lazy(() => import('mui-rte'))

export default function ProjectPreviewPart({ project, titleClass }) {

  return (
    <Suspense fallback={<div></div>}>
      <h1 className={`text-3xl ${titleClass}`}>{project.name}</h1>
      <MUIRichTextEditor defaultValue={project.description} readOnly controls={[]}/>
      <img className="rounded-md w-full" src={project.hero_image?.url} />
    </Suspense>
  )
}